import { z } from 'zod';

import { GenderEnum, StepColorEnum } from '../../enums';
import {
  levelEnumValidator,
  optionalImageUrlValidator,
  uuidValidator,
} from '../../validators';

import { ResourceLinkSchema } from './resource-link.dto';
import { TranslationsSchema } from './translation.dto';

const WordGroupBasicSchema = z.object({
  color: z.nativeEnum(StepColorEnum),
  id: uuidValidator,
  name: z.string(),
});

export const WordResponseSchema = z.object({
  gender: z.nativeEnum(GenderEnum).nullable(),
  id: uuidValidator,
  imageUrl: optionalImageUrlValidator,
  isShared: z.boolean().optional(),
  level: levelEnumValidator.nullable(),
  notes: z.string().nullable(),
  partizip2: z.string().nullable(),
  plural: z.string().nullable(),
  prateritum: z.string().nullable(),
  resourceLinks: z.array(ResourceLinkSchema).optional(),
  text: z.string(),
  translations: TranslationsSchema,
  userId: uuidValidator,
  wordGroups: z.array(WordGroupBasicSchema).optional(),
});

export type IWordResponseDto = z.infer<typeof WordResponseSchema>;
